import { httpUtils } from "src/infra/http/utils";
import { inject, injectable } from "tsyringe";
import { Observable } from "rxjs";
import { autoBind } from "src/shared/decorators/autobind";
import { GeographicLocation } from "src/shared/types/entities";
import type { HttpRequestClient } from "src/infra/http/types";

export interface IGeolocationRepository {
    getGeoLocations(): Observable<GeographicLocation[]>;
}

@injectable()
export class GeolocationRepository implements IGeolocationRepository {
    constructor(@inject("HttpClient") private http: HttpRequestClient) {}

    @autoBind
    getGeoLocations(): Observable<GeographicLocation[]> {
        const endpoint = GeolocationRepository.getGeoLocationUrl();
        return this.http.get<GeographicLocation[]>(endpoint, {
            isPublicRequest: false,
            customHeader: {
                ...httpUtils.getBaseHeaders(),
                ...httpUtils.getMsBaseHeaders(window.userIdentity, "MEP"),
            },
        });
    }

    private static getGeoLocationUrl(): string {
        return "geographic-locations";
    }
}
